import { styled } from "@mui/material/styles";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
export const UncheckedIcon = styled(CheckBoxOutlineBlankIcon)(({ theme }) => ({
    color: theme.palette.primary.main
}));
